<template>
    <div class="story-maker-highlight-menu">

        <div class="btns-action">
            <div class="btn cancel" @click="close">
                <img :src="require('@/assets/img/instagram/instagram_x_outline_44.png')">
            </div>
        </div>
     
        <div class="bottom-sheet">
            <template v-if="highlights && Array.isArray(highlights)">
                <template 
                    v-if="
                        (
                            highlights.length == 0 && 
                            !highlightSelected
                        ) || section == 'newHighlight'
                        "
                >
                    <h4>{{ $t('dash.post-creator.story.highlight.new') }}</h4>
                    <div class="content-new-highlight">
                        <div class="container-highlight-picture">
                            <div class="highlight-picture">
                                <div 
                                    class="container-img" 
                                    :style="{backgroundColor : storySelected.background.color}"
                                >
                                    <template v-if="storySelected.background.file">
                                        <img 
                                            v-if="storySelected.background.file.info.type2 == 'image'" 
                                            :src="storySelected.background.file.url"
                                        >
                                        <video 
                                            v-else-if="storySelected.background.file.info.type2 == 'video'" 
                                            :src="storySelected.background.file.url" 
                                            :type="storySelected.background.file.info.type" 
                                            preload="metadata" 
                                            class="source" 
                                            onloadedmetadata="true"
                                            muted loop playsinline 
                                        />
                          
                                    </template>
                                </div>
                            </div>
                        </div>
                        <input :placeholder="$t('dash.post-creator.story.highlight.name-placeholder')" v-model="models.highlightName">
                        <div class="button"  @click="addHighlight" v-if="models.highlightName.length">
                            {{ $t('dash.post-creator.story.highlight.add-button') }}
                        </div>
                        <div class="button" @click="()=> {
                            if (!highlights.length) { close() }else{ section = 'home' }
                        }" v-else>
                            {{ $t('dash.button.go_back') }}
                        </div>
                    </div>
                </template>

                <template v-else>
                    <h4>{{ $t('dash.post-creator.story.highlight.add-to') }}</h4>
                    <div class="content-pick-highlight">
                        <div class="list hide-scrollbar">
                            
                            <template>
                                <div class="container-highlight-new" @click="section = 'newHighlight'">
                                    <div class="highlight-icon">
                                        <img :src="require('@/assets/img/instagram/instagram_x_outline_44.png')">
                                    </div>
                                    <p>{{ $t('dash.post-creator.story.highlight.new-label') }}</p>
                                </div>

                                <div v-if="highlightSelected && !highlightSelected.id && highlightSelected.text" class="container-highlight-picture selected" @click="unSelectHighlight">
                                    <div class="highlight-picture">
                                        <div class="container-img" :style="{backgroundColor : storySelected.background.color}">
                                            <template v-if="storySelected.background.file">
                                                <img 
                                                    v-if="storySelected.background.file.info.type2 == 'image'" 
                                                    :src="storySelected.background.file.url"
                                                >
                                                <video 
                                                    v-else-if="storySelected.background.file.info.type2 == 'video'" 
                                                    :src="storySelected.background.file.url" 
                                                    :type="storySelected.background.file.info.type" 
                                                    preload="metadata" 
                                                    class="source" 
                                                    onloadedmetadata="true"
                                                    muted loop playsinline 
                                                />
                                
                                            </template>
                                        </div>
                                    </div>
                                    <p>{{ highlightSelected.text }}</p>
                                </div>

                                <div 
                                    v-for="highlight in highlights"
                                    :class="['container-highlight-picture',{selected: highlightSelected && highlightSelected.id == highlight.id}]"
                                    @click="()=>selectHighlight(highlight)" 
                                >
                                    <div class="highlight-picture">
                                        <div class="container-img">
                                            <img :src="highlight.img">
                                        </div>
                                    </div>
                                    <p>{{ highlight.title }}</p>
                                </div>
                            </template>
                           
                            
                        </div>
                        <div class="button" @click="close">
                            {{ $t('dash.button.close') }}
                        </div>
                    </div>
                </template>
                
            </template>
            <span class="loader" v-else></span>
            
        </div>
      

    </div>
</template>

<script>
    import { VueDraft } from '@mashupweb/draft-lib';
    import { Story } from '@mashupweb/draft-lib/dist/form/story/entities/story';
    import StoryForm from '@mashupweb/draft-lib/dist/form/story/Form';
    export default {
        props: {

            files:Object,
            
            storySelected:Story,
            formInstance:StoryForm
        },
        data() {
            return {
                highlights: null,
                highlightSelected: null,
                models: {
                    highlightName : ''
                },
                section: 'home',
            }
        },

        created() {
            this.loadHighlights() 
            this.refreshHighlightSelected()
        },

        methods: {
            close() {
              this.$emit('close')  
            },

            async loadHighlights() {
                this.highlights = await this.formInstance.merge.target?.getHighlights()
            },

            addHighlight() {
                this.storySelected.highlights.set(
                    this.formInstance.merge.target.id,
                    {
                        id: null,
                        text: this.models.highlightName,
                    }
                )
                this.$set(this.models, 'highlightName', '')
                this.section = 'home'
                this.refreshHighlightSelected()
            },

            selectHighlight(highlight) {
                if (this.highlightSelected && this.highlightSelected.id == highlight.id) {
                    this.unSelectHighlight()
                } else {
                    this.storySelected.highlights.set(
                        this.formInstance.merge.target.id,
                        {
                            id: highlight.id,
                            text: highlight.title,
                        }
                    )
                }
                this.refreshHighlightSelected()
            },

            unSelectHighlight() {
                this.storySelected.highlights.remove(this.formInstance.merge.target.id)
                this.refreshHighlightSelected()
            },

            refreshHighlightSelected() {
                this.highlightSelected = this.storySelected.highlights?.[this.formInstance.merge.target.id] || null
            }
        },

        computed: {
          
        }
    }
</script>

<style lang="scss" scoped>

</style>